import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 bg-surface-0 p-6 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-surface-2 text-ink-faint">
        <Compass className="h-7 w-7" />
      </span>
      <div>
        <h1 className="text-lg font-semibold text-ink">This page does not exist</h1>
        <p className="mt-1 text-sm text-ink-muted">The link may be out of date, or the screen arrives in a later phase.</p>
      </div>
      <Link to="/"><Button>Back to dashboard</Button></Link>
    </div>
  );
}
